module.exports = __webpack_public_path__ + "assets/normal/images/channel.e25076a9.png";